import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-manage-consents',
  templateUrl: './default-manage-consents.component.html',
  styleUrls: ['./default-manage-consents.component.scss']
})
export class DefaultManageConsentsComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
